import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { toLocaleString } from '@/utils/format/number';
/**
 * 数字カンマ区切りで表示するためのコンポーネント
 * @param props
 * @constructor
 */
export const NumberText = (props) => {
    const { value } = props;
    const text = useMemo(() => toLocaleString(value), [value]);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(_Fragment, { children: text });
};
